export default __webpack_public_path__ + "static/fish1-6b5d3f24c07a1f335c59a4a09b2b885a.svg";